import { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThemeState } from "../../dtos/common/ThemeState";
import { Themes } from "../../data/Themes";
import { AppModeState } from "../../dtos/common/AppModeState";
import { AppMode } from "../../data/AppMode";
import { Card } from "primereact/card";
import { Accordion, AccordionTab } from "primereact/accordion";
import "../../css/components/employeeBilling.css";
import { MultiSelect } from "primereact/multiselect";
import { getProjectByUser } from "../../service/project/ProjectService";
import { ProjectItemsDto } from "../../dtos/project/ProjectItemsDto";
import {
  createBulkBillings,
  createEmployeeBilling,
  getAllEmployeeBillingData,
} from "../../service/employeeBilling/EmployeeBillingService";
import { AllEmployeeBillingDataDto } from "../../dtos/employeeBilling/AllEmployeeBillingDataDto";
import { EmployeeBillingProjectsDto } from "../../dtos/employeeBilling/EmployeeBillingProjectsDto";
import { EmployeeBillingTasksDto } from "../../dtos/employeeBilling/EmployeeBillingTasksDto";
import { InputForCreateOrUpdateEmployeeBillingDto } from "../../dtos/employeeBilling/InputForCreateOrUpdateEmployeeBillingDto";
import { InputTimeDifference } from "../subComponents/InputTimeDifference";
import { ShowMinToHourAndMin } from "../../shared/functions/ShowMinToHourAndMin";
import { ISTToDate } from "../../shared/functions/ISTToDate";
import { Dropdown } from "primereact/dropdown";
import { getNextDate } from "../../shared/functions/GetNextDate";
import { getEmployeeDetailsByAccess, getSubordinatesNameIDCode } from "../../service/employee/employeeService";
import { Button } from "primereact/button";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { isDateValid } from "../../shared/functions/IsValidDateFunc";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SelectButton } from "primereact/selectbutton";
import { GetPrevFirstAndLastDayOfWeek } from "../../shared/functions/GetPrevFirstAndLastDayOfWeek";
import { GetNextFirstAndLastDayOfWeek } from "../../shared/functions/GetNextFirstAndLastDayOfWeek";
import { ProjectBillingDatesDto } from "../../dtos/projectBilling/ProejctBillingDatesDto";
import { LoggedInUserData } from "../../shared/functions/LoggedInUserData";
import { Tooltip } from "primereact/tooltip";
import { EmployeeBillingInputDto } from "../../dtos/employeeBilling/EmployeeBillingInputDto";
import { ProjectDetailsDto } from "../../dtos/employeeBilling/ProjectDetailsDto";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { updateEmployeeBillingTime } from "../../shared/constant/PermissionVariables";
import { isPermissionGiven } from "../../shared/functions/HasPermission";
import { InputNumber } from "primereact/inputnumber";

export const EmployeeBilling = () => {
  //#region all Variables

  const themeName = useSelector((state: ThemeState) => state.theme.themeName);
  const ThemeColors = Themes.find((th) => th.name === themeName);
  const modeName = useSelector((state: AppModeState) => state.theme.appMode);
  const mode = AppMode.find((md) => md.name === modeName);
  const dispatch = useDispatch();
  const [data, setData] = useState<EmployeeBillingProjectsDto[]>([]);
  const [employee, setEmployee] = useState<any[]>([]);
  const employeeOptions = employee?.map((emp) => ({
    label: `${emp.fullName} (${emp.employeeCode})`,
    value: emp, // You can set the entire employee object as the value if needed
  }));
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [project, setProject] = useState<ProjectItemsDto[]>([]);
  const [selectedProject, setSelectedProject] = useState<string[] | null>(null);
  const [date, setDate] = useState<any>(new Date());
  const localization = useSelector(
    (state: any) => state.localization.localization
  );
  const [employeeName, setEmployeeName] = useState("");
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeCode, setEmployeeCode] = useState("");
  const [employeeTotalBillingTime, setEmployeeTotalBillingTime] = useState<number>(0);
  const [calender, setCalender] = useState(
    <DatePicker selected={date} onChange={(e) => setDate(e as Date)} />
  );
  const [noData, setNodata] = useState("");
  const buttons: any[] = [
    { name: localization?.Day || "Day", value: "day" },
    { name: localization?.Week || "Week", value: "week" },
  ];
  const [dateType, setDateType] = useState<string>(buttons[0].value);
  const [isLoggedInUser, setIsLoggedInUser] = useState<boolean>(false);
  const [disableSelectBtn, setDisableSelectBtn] = useState<boolean>(false);
  const [weekDate, setWeekDate] = useState<any>(new Date());
  const [prevDate, setPrevDate] = useState<any>(new Date());
  const [billingData, setBillingData] = useState<EmployeeBillingProjectsDto[]>([]);
  const toast = useRef<any>(null);
  const userPermissions = useSelector((state: any) => state.permission.permissions);
  //#endregion

  //#region all Functions

  function calculateTotalBillingTime(data: EmployeeBillingProjectsDto[]) {
    let totalBillingTime = 0;

    data.forEach((project) => {
      project.tasks.forEach((task) => {
        task.datesOfTask.forEach((date) => {
          totalBillingTime += date.billingTimeInMinute as number;
        });
      });
    });

    return totalBillingTime;
  }

  const afterCreateDataFunc = (
    input: InputForCreateOrUpdateEmployeeBillingDto
  ) => {
    setData((prevData) => {
      const newData = [...(prevData as EmployeeBillingProjectsDto[])];

      for (const proj of newData) {
        if (proj.projectId === input.ProjectID) {
          for (const task of proj.tasks) {
            if (task.taskId === input.TaskID && task.taskName === input.TaskName) {
              for (const dates of task.datesOfTask) {
                if (dates.date === input.TrackingDate) {
                  dates.billingTimeInMinute =
                    input.BillingTimeInMinute as number;
                } else {
                  dates.billingTimeInMinute = dates.billingTimeInMinute;
                }
              }
            }
          }
        }
      }

      return newData;
    });

    const totalBillTime = calculateTotalBillingTime(data);
    setEmployeeTotalBillingTime(totalBillTime);
  };

  const createEmpAndProjArr = (arr: any[]) => {
    const data: ProjectDetailsDto[] = [];
    arr?.forEach((e: any) => {
      data.push({
        id: e.id,
        name: e.name
      });
    });

    return data;
  };

  const getAllData = async () => {
    setDisableSelectBtn(true);
    
    // getting logged in user's employee code
    const loggedInUser = await LoggedInUserData(dispatch);

    let validDateOrNot: boolean[] = [];
    if (Array.isArray(date)) {
      date.map((val) => {
        const isValidDate = isDateValid(val);
        validDateOrNot.push(isValidDate);
      });
    } else {
      const isValidDate = isDateValid(date);
      validDateOrNot.push(isValidDate);
    }

    if (!validDateOrNot.includes(false)) {
      let startDate = "";
      let endDate = "";
      const today = ISTToDate(date);
      if (Array.isArray(today)) {
        startDate = today[0];
        endDate = today[1];
      } else {
        startDate = today;
        endDate = getNextDate(today as string);
      }

      if (typeof selectedEmployee === 'undefined') {
        setSelectedEmployee(null)
        setDisableSelectBtn(false);
        setData([]);
        return;
      }

      if (selectedEmployee === null) {
        setDisableSelectBtn(false);
        setData([]);
        return;
      }


      const input: EmployeeBillingInputDto = {
        StartTime: startDate,
        EndTime: endDate,
        UserIds: selectedEmployee?.id,
        ProjectDetails: createEmpAndProjArr(selectedProject as string[]),
        loggedInUserEmpCode: loggedInUser?.EmployeeCode,
      };

      const res: AllEmployeeBillingDataDto[] =
        await getAllEmployeeBillingData(dispatch, input);
      if (res?.length > 0) {
        setData(res[0]?.projects);
        setBillingData(res[0]?.projects);
        setEmployeeName(res[0]?.fullName);
        setEmployeeCode(res[0]?.employeeCode);
        setEmployeeId(res[0]?.id);
        handleEmpBillTime(res[0]?.projects);
        setIsLoggedInUser(res[0]?.isLoggedInUser);
        setNodata("");
      } else {
        setData([]);
        setEmployeeName("");
        setEmployeeId(0);
        setEmployeeCode("");
        setEmployeeTotalBillingTime(0);
        setNodata("Sorry there is no data to show for this match");
      }
    } else {
      setNodata("Please provide a valid date in MM/DD/YYYY to show the data.");
    }
    setDisableSelectBtn(false);
  };

  const getAllEmployees = async () => {
    const employees = await getEmployeeDetailsByAccess(dispatch);
    setEmployee(employees);
  };

  const getAllProjects = async () => {
    const projects = await getProjectByUser(dispatch,null);
    setProject(projects?.result?.projects);
  };

  const handleSave = async (
    e: number,
    data: InputForCreateOrUpdateEmployeeBillingDto
  ) => {
    const hasPermission = isPermissionGiven(updateEmployeeBillingTime, userPermissions, dispatch); 
    if(!hasPermission){
      return 
    }
    const createData: InputForCreateOrUpdateEmployeeBillingDto = {
      EmployeeID: employeeId,
      EmployeeName: employeeName,
      EmployeeCode: employeeCode,
      ProjectID: data.ProjectID,
      ProjectName: data.ProjectName,
      TaskID: data.TaskID,
      TaskName: data.TaskName,
      TrackTimeInMinute: Math.round(data.TrackTimeInMinute),
      BillingTimeInMinute: e,
      TrackingDate: data.TrackingDate,
    };
    await createEmployeeBilling(dispatch, createData);
    afterCreateDataFunc(createData);
  };

  const handleEmpBillTime = (arr: EmployeeBillingProjectsDto[]) => {
    let total: number = 0;
    let totalTaskBillTime: number = 0;
    arr.forEach((proj) => {
      proj.tasks.forEach((tsk) => {
        tsk.datesOfTask.forEach((date) => {
          totalTaskBillTime += date?.billingTimeInMinute as number;
        });
      });
    });
    total += totalTaskBillTime;

    setEmployeeTotalBillingTime(total);
  };

  const handleProjBillTime = (arr: EmployeeBillingTasksDto[]) => {
    let res = 0;
    arr.forEach((tsk) => {
      tsk.datesOfTask.forEach((date) => {
        res += date.billingTimeInMinute;
      });
    });
    return res;
  };

  const handlePrevDate = (type: string, date: any) => {
    if (type === "day") {
      const previous = new Date(date?.getTime());
      previous.setDate(date?.getDate() - 1);
      setPrevDate(date?.getDate() - 1)
      setDate(previous);
    } else if (type === "week") {
      const daysOfWk = GetPrevFirstAndLastDayOfWeek(date);
      const dateRange = [];
      dateRange.push(daysOfWk.first, daysOfWk.last);
      setDate(dateRange);
      setWeekDate(dateRange)
    }
  };

  const handleNextDate = (type: string, date: any) => {
    if (type === "day") {
      const next = new Date(date?.getTime());
      next.setDate(date?.getDate() + 1);
      if(next>new Date()){
        toast.current.show({
          severity: "warn",
          summary: "Sorry!",
          detail: "You can't go to the upcoming days!",
          life: 3000,
        });
        return;
      }
      setDate(next);
      setPrevDate(next);
    }
    //  else if (type === "week") {
    //   const daysOfWk = GetNextFirstAndLastDayOfWeek(date);
    //   const dateRange = [];
    //   dateRange.push(daysOfWk.first, daysOfWk.last);
    //   setDate(dateRange);
    //   setWeekDate(dateRange)
    // }
    else if (type === "week") {
      const currentDate = new Date();
    
      // Calculate the start and end of the current week
      const currentWeekStart = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - currentDate.getDay() // Start of the week (Sunday)
      );
      const currentWeekEnd = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + (6 - currentDate.getDay()) // End of the week (Saturday)
      );
    
      // Get the next week's start and end dates using the function
      const daysOfWk = GetNextFirstAndLastDayOfWeek(date);
    
      // Compare next week with the current week
      if (daysOfWk.first > currentWeekEnd) {
        toast.current.show({
          severity: "warn",
          summary: "Sorry!",
          detail: "You can't go to the upcoming weeks!",
          life: 3000,
        });
        return;
      }
    
      // Proceed with setting the next week if it's valid
      const dateRange = [daysOfWk.first, daysOfWk.last];
      setDate(dateRange);
      setWeekDate(dateRange);
    }
  };

  const getFirstAndLastDayOfWeek = (date: any) => {
    const today = new Date(date); // Create a clone of the input date

    const currentDate = new Date();
    
    // Calculate the start and end of the current week
    const currentWeekStart = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() - currentDate.getDay() // Start of the week (Sunday)
    );
    const currentWeekEnd = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + (6 - currentDate.getDay()) // End of the week (Saturday)
    );

    // Set the first day of the week (Monday)
    const firstDay = new Date(today);
    firstDay.setDate(
      today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1)
    );

    // Set the last day of the week (Sunday)
    const lastDay = new Date(firstDay);
    lastDay.setDate(firstDay.getDate() + 6);

    if (firstDay > currentWeekEnd) {
      toast.current.show({
        severity: "warn",
        summary: "Sorry!",
        detail: "You can't go to the upcoming weeks!",
        life: 3000,
      });
      return;
    }

    const weekDates = [firstDay, lastDay];
    setDate(weekDates); // Assuming setDate is a function you want to use to set the week dates
    setWeekDate(weekDates)
  };

  //after clicking the day button dates will set to day
  const handleDay = () => {
    setDate(prevDate);
  };

  //after clicking the week button dates will set to week

  const handleWeek = () => {
    if (weekDate.length > 0) {
      const dt = [weekDate[0], weekDate[1]];
      setDate(dt);
    }
    else {

      const today = new Date(weekDate);
      const first = new Date(today);
      first.setDate(
        today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1)
      );
      const last = new Date(first);
      last.setDate(first.getDate() + 6);
      const dateRange = [first, last];
      setDate(dateRange);
    }
  };


  const handleDateType = (e: any) => {
    let dateTypeForPicker = "";
    if (e.value === null) {
      dateTypeForPicker = dateType;
      setDateType((prev: any) => {
        return prev;
      });
    } else {
      setDateType(e.value);
      dateTypeForPicker = e.value;
    }

    if (e.value === "day") {
      handleDay();
    } else if (e.value === "week") {
      handleWeek()
    }
  };

  const handleCalender = () => {
    if (dateType === "day") {
      setCalender(
        <DatePicker selected={date} 
        onChange={(e) =>{
          if ( e && e >= new Date()) {
            toast.current.show({
              severity: "warn",
              summary: "Sorry!",
              detail: "You can't go to the upcoming weeks!",
              life: 3000,
            });
            return;
          }
          setDate(e as Date)
        }} 
        />
      );
      setPrevDate(date)
    } else if (dateType === "week") {
      setCalender(
        <DatePicker
          selectsRange={date}
          customInput={<CustomInput />}
          startDate={date[0]}
          endDate={date[1]}
          onChange={(e: any) => getFirstAndLastDayOfWeek(e)}
          dateFormatCalendar="MMMM yyyy"
        />
      );
      setWeekDate(date)
    }
  };

  const calculateTotalDatesBillTime = (arr: ProjectBillingDatesDto[]) => {
    return arr.reduce(
      (total, date) => (total + date?.billingTimeInMinute) as number,
      0
    );
  };

  const handleAllTrackingToBill = async () => {
    let input: InputForCreateOrUpdateEmployeeBillingDto[] = [];

    billingData.forEach(billData => {

      billData.tasks.forEach(task => {
        task.datesOfTask.forEach(date => {
          input.push({
            TaskID: task.taskId,
            TaskName: task.taskName,
            EmployeeCode: employeeCode,
            EmployeeID: employeeId,
            EmployeeName: employeeName,
            ProjectID: billData.projectId,
            ProjectName: billData.projectName,
            TrackingDate: date.date,
            BillingTimeInMinute: date.totalTrackTimeInMinute ?? 0,
            TrackTimeInMinute: date.totalTrackTimeInMinute ?? 0,
          })
        })
      })
    })

    await createBulkBillings(dispatch, input);

    await getAllData();

    toast.current.show({ severity: 'success', summary: 'Success!', detail: "You have successfully save all the tracking time to billing time!", life: 3000 });
  }


  //#endregion

  //#region all Templates
  const CustomInput = forwardRef(({ value, onClick }: any, ref: any) => (
    <div className="example-custom-input" onClick={onClick} ref={ref}>
      {value}
    </div>
  ));

  const startToolbar = () => {
    return (
      <div>
        <h4>{localization?.EmployeeBilling || "Employee Billing"}</h4>
        <p>
          {localization?.EmployeeName || "Employee Name"}:{" "}
          {selectedEmployee?.fullName}{" "}
          {selectedEmployee && `(${selectedEmployee?.employeeCode})`}{" "}
        </p>
        <p>
          {localization?.BillingTime || "Billing Time"}:
          {selectedEmployee === null
            ? ""
            : ShowMinToHourAndMin("", employeeTotalBillingTime)}
        </p>
      </div>
    );
  };

  const endToolbar = () => {
    return (
      <div className="endToolbarPerformance">

        <Button label="Set Billing" onClick={handleAllTrackingToBill} disabled={data.length === 0 || disableSelectBtn} />

        <Dropdown
          value={selectedEmployee}
          onChange={(e) => setSelectedEmployee(e.value)}
          options={employeeOptions}
          placeholder={localization?.SelectEmployees || "Select Employees"}
          filter
          resetFilterOnHide={true}
          className="w-full md:w-13rem inner_dropdown"
          style={{ width: "11rem" }}
          showClear
          panelStyle={{ backgroundColor: mode?.backgroundSecondaryColor, color: mode?.color }}
        />

        <MultiSelect
          value={selectedProject}
          filter
          resetFilterOnHide={true}
          disabled={selectedEmployee === null ? true : false}
          onChange={(e) => setSelectedProject(e.value)}
          options={project}
          optionLabel="name"
          placeholder={localization?.SelectProjects || "Select Projects"}
          className="w-full md:w-13rem select_width_issue"
          style={{ width: "11rem" }}
          display="chip"
          panelStyle={{ backgroundColor: mode?.backgroundSecondaryColor, color: mode?.color }}
        />

        <SelectButton
          value={dateType}
          onChange={(e) => handleDateType(e)}
          optionLabel="name"
          options={buttons}
          disabled={disableSelectBtn}
        />

        {/* date component *********************/}
        <div className="date-input border_primary flex-fill rounded-3 ">
          <Button
            icon={<AiOutlineLeft />}
            onClick={() => handlePrevDate(dateType, date)}
            className="date-comp-prev-btn"
            disabled={disableSelectBtn}
          />
          {/* <Calendar value={date} onChange={(e) =>  setDate(e.value as Date) } style={{ width: '10rem' }} inputClassName="date-comp" /> */}
          {calender}
          <Button
            icon={<AiOutlineRight />}
            onClick={() => handleNextDate(dateType, date)}
            className="date-comp-next-btn"
            disabled={disableSelectBtn}
          />
        </div>
      </div>
    );
  };

  //#endregion

  useEffect(() => {
    getAllEmployees();
    getAllProjects();
  }, []);

  useEffect(() => {
    handleCalender();
  }, [dateType, date]);

  useEffect(() => {
    getAllData();
    if (selectedEmployee === null) {
      setNodata("Please select an employee for data");
    }
  }, [date, selectedEmployee, selectedProject]);

  return (
    <div className="empoloyee_sec">
      <Toast ref={toast} />
      <Toolbar
        start={startToolbar}
        end={endToolbar}
        // style={{
        //   backgroundColor: mode?.backgroundSecondaryColor,
        //   color: mode?.color,
        // }}
        className="bg-transparent border-0 p-0 mb-3"
      />
      <div
        // style={{
        //   backgroundColor: mode?.backgroundSecondaryColor,
        //   color: mode?.color,
        // }}
      >
        {noData.length > 0 ? (
          <div className="no-data">{noData}</div>
        ) : (
          <div className="main-project-billing main_project_billing employeeBillingCont">
            {data?.map((proj: EmployeeBillingProjectsDto) => {
              const projectBillingTime = handleProjBillTime(proj.tasks);
              return (
                <Accordion activeIndex={0} key={proj.projectId} className="rounded-2 overflow-hidden empAcord border_primary custom-accordion">
                  <AccordionTab
                    key={proj.projectId}
                    headerClassName="employee-billing-head"
                    headerStyle={{
                      backgroundColor: ThemeColors?.primaryColor,
                      color: ThemeColors?.fontColor,
                    }}
                    header={
                      <div
                        className="employee-billing-employee-part input_billing ps-4"
                        key={proj.projectId}
                      >
                        <Tooltip
                          target=".task-name"
                          mouseTrack
                          mouseTrackLeft={10}
                        />
                        <span
                          className="task-name"
                          data-pr-tooltip={proj?.projectName}
                        >
                          {proj?.projectName?.length > 30
                            ? `${proj?.projectName?.slice(0, 31)}...`
                            : proj?.projectName}
                        </span>
                        <span>
                          Total Track Time:{" "}
                          {ShowMinToHourAndMin(
                            "",
                            proj.totalTrackTimeInMinute
                          )}
                        </span>
                        <span>
                          {ShowMinToHourAndMin(
                            "Billing Time: ",
                            projectBillingTime
                          )}
                        </span>
                      </div>
                    }
                  >
                    {proj?.tasks?.map((task: EmployeeBillingTasksDto) => {
                      const billingTime = calculateTotalDatesBillTime(
                        task.datesOfTask
                      );

                      return (
                        <Accordion activeIndex={Array.from(Array(task?.datesOfTask?.length).keys())} multiple>
                          <AccordionTab
                            key={task.taskId}
                            headerClassName="employee-billing-head seceond_head"
                            header={
                              <div
                                className="employee-billing-task-part"
                                key={task.taskId}
                              >
                                <span className="employee-billing-emp-name">
                                  {task.taskName}
                                </span>
                                <span>
                                  {ShowMinToHourAndMin(
                                    "",
                                    Number(task.totalTrackTimeInMinute)
                                  )}
                                </span>
                                <span>
                                  {ShowMinToHourAndMin("", billingTime)}
                                </span>
                              </div>
                            }
                          >
                            {task?.datesOfTask?.map((date) => (
                              <div
                                key={date.date}
                                className="ebtp employee-billing-task-part"
                                style={{ color: mode?.color }}
                              >
                                <span className="ebtpDate">{date.date}</span>
                                <span className="ebtpTime">
                                  {ShowMinToHourAndMin(
                                    "",
                                    Number(date?.totalTrackTimeInMinute)
                                  )}
                                </span>
                                <span className="ebtpHour">
                                 
                                  <InputTimeDifference
                                    isloggedIn={isLoggedInUser}
                                    timeInMin={
                                      date?.billingTimeInMinute as number
                                    }
                                    handleSave={(e: any) =>
                                      handleSave(e, {
                                        ProjectID: proj.projectId,
                                        ProjectName: proj.projectName,
                                        TaskID: task.taskId,
                                        TaskName: task.taskName,
                                        TrackTimeInMinute:
                                          date.totalTrackTimeInMinute,
                                        TrackingDate: date.date,
                                      } as InputForCreateOrUpdateEmployeeBillingDto)
                                    }
                                    disabled={userPermissions.includes(updateEmployeeBillingTime)}
                                  />
                                </span>
                              </div>
                            ))}
                          </AccordionTab>
                        </Accordion>
                      );
                    })}
                  </AccordionTab>
                </Accordion>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
